export default __webpack_public_path__ + "static/media/N2P_1921.bfc26dd0.jpg";